import { createAction } from '@src/redux/helpers/createAction';

import { SET_RELOAD_POPUP } from './constants';

export const setReloadPopup = (payload) => {
  return createAction({
    type: SET_RELOAD_POPUP,
    payload,
  });
};
